export default __webpack_public_path__ + "static/dfat-66f36a1d5d8f74c123162dee38e6edf6.png";